module.exports = __webpack_public_path__ + "media/images/payment/maestro-11a4ac3a9bae83fae971ebf226317bd6.png";